import React from 'react';
import Layout from '../../Layout/Layout.jsx';
import AlertDialogSlide from '../../components/TransitionModal/TransitionModalNoButton.jsx';
import Loading from '../../components/Loading/Loading.jsx';
import getFileData, { fetchPublicDataFile } from '../../APICall/Api.jsx';

const normalizeImageUrl = (url) => {
  const clean = (url || '').trim();
  if (!clean) return '';
  if (/^https?:\/\//i.test(clean) || clean.indexOf('//') === 0) {
    return encodeURI(clean);
  }
  return encodeURI(`https://buildgreenalbania.org/${clean.replace(/^\/+/, '')}`);
};
const getImageUrl = (item) => {
  if (!item) return '';
  if (item.foto) return item.foto;
  if (item.photo) return item.photo;
  if (item.image) return item.image;
  if (item.img) return item.img;
  if (item.thumbnail) return item.thumbnail;
  if (item.images && item.images.length) return item.images[0];
  return '';
};

class GenericPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components,
      error: null,
      materials: {},
      currentPage: [],
      pages: [],
      activePage: 0,
      isLoaded: false,
      url: getFileData,
    };
  }

  splitIntoPages = (items) => {
    const size = 6;
    const result = [];
    for (let i = 0; i < items.length; i += size) result.push(items.slice(i, i + size));
    return result;
  };

  componentDidMount() {
    this.callAPI(
      this.props.match.params.lang.capitalize(),
      this.props.match.params.component.capitalize(),
    );
  }

  componentWillReceiveProps(next) {
    this.setState({ language: window.language.setLanguage(next.match.params.lang).components });
    if (
      next.match.params.lang !== this.props.match.params.lang ||
      next.match.params.component !== this.props.match.params.component
    ) {
      this.setState({ isLoaded: false });
      this.callAPI(
        next.match.params.lang.capitalize(),
        next.match.params.component.capitalize(),
      );
    }
  }

  callAPI = (lang, component) => {
    fetchPublicDataFile(`${component}${lang}.json`)
      .then(
        (result) => {
          const key = component.charAt(0).toLowerCase() + component.slice(1);
          const elements = result[key].elements.slice().reverse();
          const pages = this.splitIntoPages(elements);
          this.setState({ isLoaded: true, materials: result[key], pages, currentPage: pages[0] || [], activePage: 0 });
        },
        (error) => this.setState({ isLoaded: true, error }),
      );
  };

  goToPage = (idx) => {
    this.setState({ currentPage: this.state.pages[idx], activePage: idx });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    if (this.state.error)    return <div style={{ padding: 40 }}>Error loading content.</div>;
    if (!this.state.isLoaded) return <Loading />;

    const { materials, currentPage, pages, activePage } = this.state;

    return (
      <Layout
        language={window.language.setLanguage(this.props.match.params.lang).components}
        color="white"
        {...this.props}
      >
        {/* Page hero */}
        <div className="bgg-page-hero">
          <div className="bgg-container">
            <h1>{materials.title || ''}</h1>
            {materials.mainTitle && <p>{materials.mainTitle}</p>}
          </div>
        </div>

        {/* Articles grid */}
        <div style={{ background: '#f6f8fa', padding: '48px 0' }}>
          <div className="bgg-container">
            <div className="bgg-articles-grid">
              {currentPage.map((item, key) => {
                const imageUrl = getImageUrl(item);

                return (
                  <AlertDialogSlide
                    key={key}
                    title={item.title || item.titulli || ''}
                    description={item.description || item.teksti || ''}
                  >
                    <div className="bgg-article-card" style={{ cursor: 'pointer' }}>
                      <div className="bgg-article-media">
                        {imageUrl && (
                          <img
                            src={normalizeImageUrl(imageUrl)}
                            alt={item.title || item.titulli}
                            className="bgg-article-img"
                            loading="lazy"
                            decoding="async"
                            referrerPolicy="no-referrer"
                            onError={(event) => {
                              event.currentTarget.style.display = 'none';
                              if (event.currentTarget.nextSibling) {
                                event.currentTarget.nextSibling.style.display = 'flex';
                              }
                            }}
                          />
                        )}
                        <div className={`bgg-article-img-placeholder${imageUrl ? ' bgg-media-fallback' : ''}`}>
                          <i className="fas fa-leaf" />
                        </div>
                      </div>
                      <div className="bgg-article-body">
                        <div className="bgg-article-date">{item.data || item.date || ''}</div>
                        <div className="bgg-article-title">{item.title || item.titulli}</div>
                        <p className="bgg-article-excerpt">
                          {(item.description || item.teksti || '').substring(0, 120)}…
                        </p>
                        <button className="bgg-link-btn">
                          Read More <span aria-hidden="true">&rarr;</span>
                        </button>
                      </div>
                    </div>
                  </AlertDialogSlide>
                );
              })}
            </div>

            {/* Pagination */}
            {pages.length > 1 && (
              <div className="bgg-pagination">
                <button
                  className="bgg-page-btn"
                  disabled={activePage === 0}
                  onClick={() => activePage > 0 && this.goToPage(activePage - 1)}
                >‹</button>
                {pages.map((_, i) => (
                  <button
                    key={i}
                    className={`bgg-page-btn${activePage === i ? ' active' : ''}`}
                    onClick={() => this.goToPage(i)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="bgg-page-btn"
                  disabled={activePage === pages.length - 1}
                  onClick={() => activePage < pages.length - 1 && this.goToPage(activePage + 1)}
                >›</button>
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

export default GenericPage;



// WEBPACK FOOTER //
// ./src/views/GenericPage/GenericPage.jsx